import { ReactComponent as ExchangeIcon } from "@/Images/icons/Exchange.svg"
import { DepositType, maskCardNumber, useInformation, useTopUpStore } from "@usher/pe-client-front-end-lib"
import { PropsWithChildren, useMemo } from "react"
import { useIntl } from "react-intl"

const TitleRow = ({ title, children }: { title: string } & PropsWithChildren) => {
  return (
    <div className="flex flex-col gap-1 xs:flex-row xs:justify-between">
      <span className="text-[16px]">{title}</span>
      <span className="text-[16px] font-[ChakraPetchSemiBold] text-black">{children}</span>
    </div>
  )
}
export const RightSection = ({ depositType, isOrder }: { depositType?: DepositType; isOrder?: boolean }) => {
  const { $t: t } = useIntl()
  const { card, cryptoPrice, crypto, deposit, fiat, iban } = useInformation()
  const isBTC = crypto === "BTC"
  const fraction = isBTC ? 8 : 5
  const { getCryptoAmounts } = useTopUpStore((s) => ({ getCryptoAmounts: s.getCryptoAmounts }))
  const isCard = depositType === DepositType.Card
  const isIban = depositType === DepositType.IBAN
  const isTopup = !isOrder
  const { amountCrypto, commissionCrypto } = useMemo(() => getCryptoAmounts(deposit, crypto, fiat), [crypto, deposit, fiat, getCryptoAmounts])
  let msgID = "amount-to-be"
  if (isCard) msgID = "amount-issue"
  if (isIban && isOrder) msgID = "iban-amount-issue"
  return (
    <div className="top-info">
      <div>
        <div className="flex items-start gap-[20px]">
          <div className="top-info__exchange-item">
            <span>{Number(isOrder ? cryptoPrice : amountCrypto + commissionCrypto).toFixed(fraction)}</span> <p>{crypto}</p>
          </div>
          <ExchangeIcon />
          <div className="top-info__exchange-item">
            <span>{deposit}</span> <p>{fiat}</p>
          </div>
        </div>
        <div className="h-[2px] border-b-2 border-b-[#777E8A] my-[30px]" />
        <div className="flex flex-col gap-2.5">
          {isTopup && (
            <TitleRow title={t({ id: isIban ? "to-iban" : "to-card" })}>{isIban ? iban.account_number : maskCardNumber(card?.card_pan)}</TitleRow>
          )}
          <TitleRow title={t({ id: "amount-of" })}>
            {amountCrypto.toFixed(fraction)} {crypto}
          </TitleRow>
          {isTopup && (
            <TitleRow title={t({ id: "fee" })}>
              {commissionCrypto.toFixed(fraction)} {crypto}
            </TitleRow>
          )}
          {isTopup && (
            <TitleRow title={t({ id: "total-amount" })}>
              {(amountCrypto + commissionCrypto).toFixed(fraction)} {crypto}
            </TitleRow>
          )}
          <TitleRow title={t({ id: msgID })}>
            {deposit} {fiat}
          </TitleRow>
        </div>
      </div>
    </div>
  )
}
